import { fetchAuthSession } from 'aws-amplify/auth';
import { getOrCreateDeviceId } from '@/lib/deviceId';

export async function getRecordLoginUrl(): Promise<string | null> {
  const fromEnv = import.meta.env.VITE_RECORD_LOGIN_URL as string | undefined;
  if (fromEnv) return fromEnv;
  try {
    const cacheBust = import.meta.env.DEV ? `?t=${Date.now()}` : '';
    const res = await fetch(`/amplify_outputs.json${cacheBust}`, { cache: 'no-store' });
    if (res.ok) {
      const outputs = (await res.json()) as { custom?: { recordLoginUrl?: string } };
      return outputs.custom?.recordLoginUrl ?? null;
    }
  } catch {
    /* missing outputs */
  }
  return null;
}

async function authHeaders(): Promise<Record<string, string>> {
  const headers: Record<string, string> = { 'Content-Type': 'application/json' };
  const session = await fetchAuthSession();
  const token = session.tokens?.idToken?.toString();
  if (!token) throw new Error('Sign in required.');
  headers.Authorization = `Bearer ${token}`;
  return headers;
}

export async function recordLoginLive(): Promise<void> {
  const url = await getRecordLoginUrl();
  if (!url) return;

  const deviceId = getOrCreateDeviceId();
  let res: Response;
  try {
    res = await fetch(url, {
      method: 'POST',
      headers: await authHeaders(),
      body: JSON.stringify({ action: 'recordLogin', deviceId }),
    });
  } catch (e) {
    console.warn('[ShopGND] Could not reach record-login service', e);
    return;
  }

  if (res.status === 404) {
    return;
  }

  if (!res.ok) {
    const data = (await res.json().catch(() => ({}))) as { error?: string };
    console.warn('[ShopGND] record-login failed', data.error ?? res.status);
  }
}
